import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {MenuComponent} from './menu/menu.component';
import {RouteUtil} from '../../util/route.util';
import {ClientDashboardComponent} from './client-dashboard/client-dashboard.component';
import {AccountComponent} from './account/account.component';
import {AddressesComponent} from './addresses/addresses.component';
import {CheckOutComponent} from './check-out/check-out.component';
import {FavoriteComponent} from './favorite/favorite.component';
import {OrdersComponent} from './orders/orders.component';
import {PaymentStatusComponent} from './payment-status/payment-status.component';
import {ProfileComponent} from './profile/profile.component';
import {BasketComponent} from './basket/basket.component';
import {AboutUsComponent} from '../common-module/about-us/about-us.component';
import {LandingComponent} from './landing/landing.component';
import {FacilityChooserComponent} from './facility-chooser/facility-chooser.component';
import {PaymentDetailComponent} from './payment-detail/payment-detail.component';
import {ServiceDetailsPageComponent} from './service-details-page/service-details-page.component';

const routes: Routes = [{
  path: RouteUtil.FACILITY_CHOOSER_COMPONENT,
  component: FacilityChooserComponent
}, {
  path: RouteUtil.CLIENT_DASHBOARD_COMPONENT,
  component: ClientDashboardComponent,
  children: [{
    path: RouteUtil.ACCOUNT_COMPONENT,
    component: AccountComponent,
    children: [{
      path: RouteUtil.ADDRESS_COMPONENT,
      component: AddressesComponent
    }, {
      path: RouteUtil.FAVORITE_COMPONENT,
      component: FavoriteComponent
    }, {
      path: RouteUtil.PROFILE_COMPONENT,
      component: ProfileComponent
    }]
  }, {
    path: `${RouteUtil.MENU_COMPONENT}/:BranchSlug`,
    component: MenuComponent
  }, {
    path: `${RouteUtil.MENU_COMPONENT}/:BranchSlug/:CategoryOrTagSlug`,
    component: MenuComponent
  }, {
    path: `${RouteUtil.ABOUT_US_COMPONENT}/:BranchSlug`,
    component: AboutUsComponent
  }, {
    path: `${RouteUtil.BASKET_COMPONENT}/:BranchSlug`,
    component: BasketComponent
  }, {
    path: `${RouteUtil.CHECK_OUT_COMPONENT}/:BranchSlug`,
    component: CheckOutComponent
  }, {
    path: `${RouteUtil.LANDING_COMPONENT}/:BranchSlug`,
    component: LandingComponent
  }, {
    path: `${RouteUtil.PAYMENT_STATUS_COMPONENT}/:BranchSlug`,
    component: PaymentStatusComponent
  }, {
    path: `${RouteUtil.PAYMENT_DETAIL_COMPONENT}/:BranchSlug`,
    component: PaymentDetailComponent
  }, {
    path: `${RouteUtil.ORDERS_COMPONENT}/:BranchSlug`,
    component: OrdersComponent
  }, {
    path: `${RouteUtil.SERVICE_DETAILS_PAGE_COMPONENT}/:BranchSlug/:ServiceSlug`,
    component: ServiceDetailsPageComponent
  }]
}, {
  path: RouteUtil.DIALOG_MODULE,
  loadChildren: () => import('./dialog/dialog.module').then(module => module.DialogModule)
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClientRoutingModule {
}
